export default __webpack_public_path__ + "static/Werner-6ceb9f45bea7d73f8e9919b9c4e93503.jpg";